import React from 'react';
import styled from 'styled-components';
import MypageLayout from '../../layouts/MypageLayout';

import BasicLayout from '../../layouts/BasicLayout';
import useCustomLogin from '../../hooks/useCustomLogin';
import Banner from '../../components/Banner';
import BreadcrumbComponent from '../../components/BreadcrumbComponent';
import LogoIcon from '../../assets/icons/Logo 2.png';
import { useParams } from 'react-router-dom';

const LogoutPage = () => {
  const { logoutType } = useParams();
  const { doLogout, moveToPath, moveToLogin } = useCustomLogin();
  // console.log(logoutType);
  const handleClickLogout = () => {
    doLogout();
    alert('로그아웃되었습니다.');
    moveToLogin();
  };

  const breadcrumb = ['홈', '로그아웃'];

  return (
    <>
      {logoutType === 'mypage' ? (
        <MypageLayout>
          <MypageContainer>
            <LogoutContainer>
              <TitleFrame>
                <LogoImg src={LogoIcon} alt="logo image" />
                <Title>한국피트니스교육연수원</Title>
              </TitleFrame>
              <Subtitle>KOREA EDUCATION INSTITUTE OF FITNESS</Subtitle>
              <Form>
                <Button onClick={handleClickLogout}>로그아웃</Button>
              </Form>
            </LogoutContainer>
          </MypageContainer>
        </MypageLayout>
      ) : (
        <BasicLayout>
          <Banner title={'로그인'} />
          <BreadcrumbComponent items={breadcrumb} />
          <Container>
            <LogoutContainer>
              <TitleFrame>
                <LogoImg src={LogoIcon} alt="logo image" />
                <Title>한국피트니스교육연수원</Title>
              </TitleFrame>
              <Subtitle>KOREA EDUCATION INSTITUTE OF FITNESS</Subtitle>
              <Form>
                <Button onClick={handleClickLogout}>로그아웃</Button>
              </Form>
            </LogoutContainer>
          </Container>
        </BasicLayout>
      )}
    </>
  );
};

const MypageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 800px;

  @media (max-width: 480px) {
    width: 100vw;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
`;

const LogoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
`;

const TitleFrame = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  gap: 4px;
  position: relative;
`;

const LogoImg = styled.img`
  width: 56px;
  height: 50px;
`;

const LogoFrame = styled.div`
  margin-top: 0.67em;
  margin-bottom: 0px;
  align-items: center;
  background-color: rgba(191, 191, 191, 1);
  color: #ffff;
  display: flex;
  gap: 8px;
  height: 42px;
  justify-content: center;
  position: relative;
  width: 51px;
`;

const Title = styled.h1`
  font-size: 34px;
  margin-bottom: 0px;
  color: #4a5568;
`;

const Subtitle = styled.p`
  margin-top: 1px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 500;
  color: #4a5568;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Button = styled.button`
  background-color: #2ac49e;
  color: white;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
  text-align: center;
  cursor: pointer;
  margin-bottom: 10px;

  /* Drop shadow 추가 */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);

  &:hover {
    background-color: #ddf6f0;
    color: #2ac49e;
  }
`;

export default LogoutPage;
